import { Box, IconButton } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { InputField } from 'components/form';
import { FinanceProgramFormValues } from 'modules/desking/types';
import SearchIcon from '@mui/icons-material/Search';
import { useNotifications } from 'modules/notification';
import { useSearchByVin } from 'modules/desking/hooks';

interface Props {
  inputFieldProps?: any;
  isSearchIconHidded?: boolean;
  handleSearchByVinResult: (result: any) => void;
}

export const SerialNumberVinInput = ({ inputFieldProps, isSearchIconHidded, handleSearchByVinResult }: Props) => {
  const { showNotification } = useNotifications();

  const { control, getValues } = useFormContext<FinanceProgramFormValues>();

  const serialNumberVin = useWatch({
    control,
    name: 'equipment.serialNumberVin',
  });

  const { getDecodedVin, isLoading } = useSearchByVin();

  const handleSearch = async () => {
    try {
      const decodedEquipmentInfo = await getDecodedVin(getValues('equipment.serialNumberVin'));
      handleSearchByVinResult(decodedEquipmentInfo);
    } catch (error) {
      showNotification('An error occurred', { type: 'error' });
    }
  };

  return (
    <Box display="flex" alignItems="center">
      <InputField control={control} label="Serial/VIN#" name="equipment.serialNumberVin" {...inputFieldProps} />
      {!isSearchIconHidded && (
        <IconButton
          type="button"
          color="primary"
          className="icon-btn-bordered"
          sx={{ ml: 1 }}
          size="small"
          onClick={handleSearch}
          loading={isLoading}
          disabled={!serialNumberVin.length}
        >
          <SearchIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};
